// src/components/pages/NotFound.tsx
//
// BUG 4 FIX: página 404 real con noindex.
// Antes: path="*" → <Navigate to="/" replace />
// Problema: URLs inventadas recibían 200 + contenido
// de homepage → Google las indexaba como páginas reales.
//
// Solución:
//   1. Este componente con meta noindex
//   2. En App.tsx sustituir el Navigate por <NotFound />
//   3. El status HTTP sigue siendo 200 (SPA limitation)
//      pero noindex evita que Google indexe esas URLs.

import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';

const NotFound = () => {
  return (
    <>
      {/* noindex: evita que Google indexe URLs inexistentes */}
      <Helmet>
        <title>Página no encontrada | Bookoll</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="relative min-h-screen flex flex-col items-center justify-center px-6 text-center overflow-hidden">
        {/* Fondo modo claro */}
        <div
          className="absolute inset-0 dark:hidden"
          style={{
            background:
              'linear-gradient(170deg, #103254 0%, #1a4a6e 40%, #288E7F 80%, #e8f4f8 100%)',
          }}
        />
        {/* Fondo modo oscuro: negro con resplandor teal, funde con el resto de la app */}
        <div
          className="absolute inset-0 hidden dark:block"
          style={{
            background:
              'linear-gradient(170deg, #050807 0%, #0a1a16 25%, #123a30 50%, #103254 75%, #000000 100%)',
          }}
        />

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="relative z-10 max-w-md"
        >
          {/* Logo */}
          <Link to="/" className="inline-block mb-10">
            <img
              src="https://ijolbckmgiwomizpzrae.supabase.co/storage/v1/object/public/bookoll/logos/logobookoll.png"
              alt="Bookoll"
              className="h-9 opacity-90"
            />
          </Link>

          {/* Número 404 */}
          <div className="text-8xl font-bold text-white/20 leading-none mb-4 select-none">
            404
          </div>

          <h1 className="text-2xl font-semibold text-white mb-3">
            Página no encontrada
          </h1>
          <p className="text-white/70 text-base leading-relaxed mb-8">
            La URL que buscas no existe o ha sido movida. Prueba buscando el
            negocio directamente desde la página principal.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              asChild
              className="bg-white text-[#103254] hover:bg-gray-100 dark:bg-[#288E7F] dark:text-white dark:hover:bg-[#1e7a6e] font-semibold rounded-xl px-6"
            >
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                Ir al inicio
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              className="border-white/40 text-white hover:bg-white/10 dark:border-white/20 dark:hover:bg-white/10 rounded-xl px-6"
            >
              <Link to="/explorar">
                <Search className="w-4 h-4 mr-2" />
                Explorar negocios
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default NotFound;